const getEventRoot = vm => {
  return vm.$root.$options.bvEventRoot || vm.$root;
};

export { getEventRoot };
